import React from 'react';

import MobileHeader from '../components/MobileHeader/MobileHeader';

import Input from 'react-bootstrap/lib/Input';
import FormSection from '../components/FormSection/FormSection';
import FormGroup from '../components/FormGroup/FormGroup';

const Support = React.createClass({

    submitForm() {

    },

    render() {
        return (
            <div className="screen-wrap">
                <MobileHeader
                    type='support'
                    title='Support'
                    // Don't show the back button on the root screen.
                    backButton={this.props.location.pathname.length > 1}
                    submitSupport={this.submitForm}
                />
                <form className="screen-content bg-gray">
                    <FormSection>
                        <FormGroup
                            label="Välj ämne"
                        >
                            <Input type="select">
                                <option></option>
                                <option value="">Undervisning</option>
                                <option value="">Lektioner</option>
                                <option value="">Utvärdering</option>
                                <option value="">Rekommendationer</option>
                                <option value="">Övrigt</option>
                            </Input>
                        </FormGroup>
                    </FormSection>
                    <FormSection>
                        <FormGroup>
                            <Input type="textarea" placeholder="Din fråga" style={{minHeight: '200'}}/>
                        </FormGroup>
                    </FormSection>
                </form>
            </div>
        );
    }

});

export default Support;



/** WEBPACK FOOTER **
 ** ./src/screens/Support.js
 **/